import React from 'react';

import PropTypes from 'prop-types';
import { Spin } from 'antd';

import PortfolioBarchart from '../../components/Charts/PortfolioBarchart';
import PortfolioTable from '../../components/PortfolioTable/PortfolioTable';
import PortfolioTableMobile from '../../components/PortfolioTableMobile/PortfolioTableMobile';
import ResponsiveSurface from '../../components/ResponsiveSurface/ResponsiveSurface';
import TradeModal from '../PropertyListing/TradeModal';
import TradeDrawer from '../PropertyListing/TradeDrawer';

const PortfolioHoldingsSection = (props) => {
  const {
    hasPortfolioData,
    isFetchingChart,
    chartData,
    portfolioBarchartInterval,
    isShowFullDate,
    openOrdersRef,
    screenSm,
    openOrdertableData,
    tableLoader,
    orderTableColumns,
    handleOnScrollIntoView,
    handleOpenEditDrawer,
    assetsData,
    assetTableColumns,
    navigate,
    screenMD,
    quickBuySecondaryOptions,
    qucikBuyPropertyDataObject,
    fetchOpenOrderTableData,
    cardRef,
    openQuickBuy,
    setOpenQuickBuy,
  } = props;

  if (!hasPortfolioData) return null;

  return (
    <>
      <div className='container-fluid'>
        <Spin spinning={isFetchingChart} wrapperClassName='graph__spin'>
          <PortfolioBarchart data={chartData} interval={portfolioBarchartInterval} isShowFullDate={isShowFullDate} valueKey='totalInvestmentAmount' />
        </Spin>
      </div>

      <div ref={openOrdersRef}></div>
      {screenSm ? (
        <PortfolioTableMobile
          PortfolioTableMobileHead='Open orders'
          tableData={openOrdertableData.openOrders}
          isOrder={true}
          onOpen={(value) => handleOpenEditDrawer(value)}
          count={openOrdertableData?.count || 0}
          handleOnScrollIntoView={handleOnScrollIntoView}
        />
      ) : (
        <PortfolioTable
          PortfolioTableHead='Open Orders'
          tableData={openOrdertableData.openOrders}
          tableLoader={tableLoader}
          count={openOrdertableData?.count || 0}
          columns={orderTableColumns}
          handleOnScrollIntoView={handleOnScrollIntoView}
          isOrder={true}
          key={'openOrder'}
        />
      )}
      <div className='container-fluid text-center'>
        <hr className='mb-10' />
      </div>
      {assetsData?.length ? (
        screenSm ? (
          <PortfolioTableMobile
            PortfolioTableMobileHead='My Assets'
            tableData={assetsData}
            count={assetsData?.length}
            onOpen={(order) => {
              navigate(`/portfolio/assets/${order?.propertyId}`);
            }}
          />
        ) : (
          <PortfolioTable count={assetsData?.length} PortfolioTableHead='My Assets' tableData={assetsData} columns={assetTableColumns} key={'Assests'} />
        )
      ) : (
        ''
      )}

      <ResponsiveSurface
        isDesktop={screenMD}
        DesktopComponent={TradeModal}
        MobileComponent={TradeDrawer}
        quickBuySecondaryOptions={quickBuySecondaryOptions}
        open={openQuickBuy}
        modalState={setOpenQuickBuy}
        quickBuyPropertyData={qucikBuyPropertyDataObject}
        isSingleTab={false}
        isSell={'1'}
        isTradeFlow
        featchData={() => {
          fetchOpenOrderTableData();
          cardRef?.current?.refreshWalletBalance();
          setOpenQuickBuy('');
        }}
      />
    </>
  );
};

PortfolioHoldingsSection.propTypes = {
  hasPortfolioData: PropTypes.bool,
  isFetchingChart: PropTypes.bool,
  chartData: PropTypes.array,
  portfolioBarchartInterval: PropTypes.number,
  isShowFullDate: PropTypes.bool,
  openOrdersRef: PropTypes.object,
  screenSm: PropTypes.bool,
  openOrdertableData: PropTypes.object,
  tableLoader: PropTypes.bool,
  orderTableColumns: PropTypes.array,
  handleOnScrollIntoView: PropTypes.func,
  handleOpenEditDrawer: PropTypes.func,
  assetsData: PropTypes.array,
  assetTableColumns: PropTypes.array,
  navigate: PropTypes.func,
  screenMD: PropTypes.bool,
  quickBuySecondaryOptions: PropTypes.object,
  qucikBuyPropertyDataObject: PropTypes.object,
  fetchOpenOrderTableData: PropTypes.func,
  cardRef: PropTypes.object,
  openQuickBuy: PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.object]),
  setOpenQuickBuy: PropTypes.func,
};

export default PortfolioHoldingsSection;
